// @flow

import React, { Component } from 'react';
import { connect } from "react-redux";
import TextTruncate from 'react-text-truncate';
import Sidebar from "react-sidebar";
import $ from'jquery';
import {
  Card,
} from "tabler-react";
import {SidebarContainerStyle} from "./style.css";
// import  '../Ticker/Ticker.js';
// import  '../Ticker/style.css';

import {TickerPlaceholder} from '../../../../utils/imageSource';

import {helper} from '../../../../utils/helpers/helper';
import { tickerActions } from '../../../../store/actions';

const mql = window.matchMedia(`(min-width: 800px)`);

class HorizontalSidebar extends Component {
  constructor(props)
  {
    super(props);
    this.state = {
      // sidebarOpen: false,
      sidebarDocked: mql.matches,
      // showFilters: true,
    };

    this.mediaQueryChanged = this.mediaQueryChanged.bind(this);
    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
  }

  componentDidMount() {
    mql.addListener(this.mediaQueryChanged);
  
    $(function(){
        $(window).on('load',function(){
              // $('.demof > ul > li:nth-child(2)').hide();
              $('.demof > ul > li').not(":first-child").hide();
        })
        $(document).ready(function(){
              // $('.demof > ul > li:nth-child(2)').hide();
              $('.demof > ul > li').children().show();
        })
        $('.ticker').easyTicker({
            direction: 'up',
            visible: 1,
            easing: 'easeOutBounce',
            interval: 2500
        });
    });
  }


  onSetSidebarOpen = () => {
    const {sidebarOpen} = this.props;
    const sidebarVal = sidebarOpen === false ? true : false;
      this.props.onSetTickerOpen(sidebarVal);
  }


  mediaQueryChanged() {
    this.props.onSetTickerOpen(false);
    this.setState({ sidebarDocked: mql.matches});
  }

  componentWillReceiveProps()
  {
      $('.ticker').easyTicker({
          direction: 'up',
          visible: 1,
          easing: 'easeOutBounce',
          interval: 2500
      });
  }

  render() {  //  showFilters
    const {sidebarOpen,tickerData} = this.props;
    // const {showFilters} = this.state;
         //check if reloaded once already
    if((Array.isArray(tickerData) && tickerData.length > 0))
    {
      return (
        <>
          <div className="text-left mb-4">
            <Sidebar
              styles={SidebarContainerStyle}
              sidebar={
                      <Card.Options className="map-ticker">
                      <div className="ticker demof">
                              <ul>
                                  {tickerData && tickerData.map((data,i) =>
                                      <li key={i}>
                                       <div className="tickerImage">
                                          <img src={data?.image !== null ?  data.image : TickerPlaceholder} alt={data.ticker_heading} />
                                      </div>
                                      <TextTruncate
                                          line={2}
                                          element="h3"
                                          truncateText="…"
                                          text={helper.capitalizeFirstLetter(data.ticker_heading)}
                                      />
                                              {/* <h3>{data.ticker_heading}</h3> */}
                                      <TextTruncate
                                          line={2}
                                          element="p"
                                          truncateText="…"
                                          text={helper.capitalizeFirstLetter(data.synopsis)}
                                      />
                                      <a href={data.url} target="_blank" rel="noopener noreferrer">See More</a>
                                      </li>
                                  )}
                              </ul> 
                          </div>
                      </Card.Options>

              }
              rootClassName="horizontalTicker"
              sidebarClassName="horizontalSidebar"
              contentClassName="horizontalSidebarContent"
              overlayClassName="horizontalSidebarOverlay"
              shadow={false}
              className="mb-4 mr-4"
              open={sidebarOpen}
              onSetOpen={this.onSetSidebarOpen}
            />
          </div>
        </>
      )
    }else{
        return true;
    }
  }
}

function mapStateToProps(state) {
  const {sidebarOpen,tickerData} = state.ticker;
  return {sidebarOpen,tickerData};
}
const mapDispatchToProps = {
  onSetTickerOpen: tickerActions.onSetTickerOpen
};
export default connect(mapStateToProps,mapDispatchToProps)(HorizontalSidebar);
